import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { fields: Array };

  connect() {
    this.formElement = this.element.closest('form');

    this.formElement.addEventListener('change', this.onFormChange);
    this.element.addEventListener('change', this.onInputChange);

    this.onFormChange();
  }

  disconnect() {
    this.element.removeEventListener('change', this.onInputChange);
    this.formElement.removeEventListener('change', this.onFormChange);
  }

  get fieldsElements() {
    return this.fieldsValue
      .map((field) => {
        const input = this.formElement.elements[field];
        if (input instanceof RadioNodeList) {
          return Array.from(input);
        }

        throw new Error(`Field ${field} is not supported`);
      })
      .flat()
      .filter((el) => el.type !== 'hidden');
  }

  onInputChange = () => {
    const { checked } = this.element;

    this.fieldsElements.forEach((el) => {
      el.checked = checked;
    });
  };

  onFormChange = () => {
    const values = this.fieldsElements.map((el) => el.checked);
    const valuesStr = values.join('::');

    if (this.comparableValues === valuesStr) {
      return;
    }

    this.element.checked = values.every((el) => el);

    this.comparableValues = valuesStr;
  };
}
